import { render, staticRenderFns } from "./DealBanner.vue?vue&type=template&id=345da088&scoped=true"
import script from "./DealBanner.vue?vue&type=script&lang=js"
export * from "./DealBanner.vue?vue&type=script&lang=js"
import style0 from "./DealBanner.vue?vue&type=style&index=0&id=345da088&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345da088",
  null
  
)

export default component.exports